import React from 'react';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import { Route, Redirect, Switch } from 'react-router-dom';
import PatientContainer from 'containers/patient/PatientContainer';
import PatientListContainer from 'containers/patient/PatientListContainer';
import { pageUrl } from 'lib/mapper';
import { useLocation } from 'react-router';
import { ProjectProvider } from 'contexts/project/ProjectContext';

function Patient() {
  const { pathname } = useLocation();

  return (
    <AppTemplate
      title={'Patient'}
      leftSide={<AppNav />}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
    >
      <ProjectProvider>
        <Switch>
          <Redirect exact path={pageUrl.patient.index} to={pageUrl.patient.list} />
          <Route path={pageUrl.patient.list} component={PatientListContainer} />
          <Route path={pageUrl.patient.detail} component={PatientContainer} />
          <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
        </Switch>
      </ProjectProvider>
    </AppTemplate>
  );
}

export default Patient;
